import type { Puzzle, PuzzleShape } from './types.ts';

/**
 * A puzzle's shape (`PuzzleShape`): every letter becomes `_`, and only the clue cells'
 * arrows are kept, never the clues' words. What a cover is drawn from.
 */
export function puzzleShape(puzzle: Pick<Puzzle, 'grid' | 'clues'>): PuzzleShape {
	return {
		grid: puzzle.grid.map((row) => row.replace(/[^#.]/g, '_')),
		arrows: puzzle.clues.map((c) => [c.cell.row, c.cell.col, c.direction]),
	};
}
